export default __webpack_public_path__ + "static/media/nada_aqui.be7a29bd.svg";